import * as React from 'react';
const styles = require('./DocumentDownload.pcss');

interface IProps {
    url : string;
    name : string;
}

export class DocumentDownload extends React.Component<IProps, {}>{
    render() {
        let { url, name } = this.props;

        return (
            <div className={styles.factsheet}>
                <svg viewBox="0 0 330 330" width="25px" height="25px">
                    <polygon className={styles.factsheetIcon} points="191.997,108 248.786,108 291.213,108 191.997,8.786 191.997,51.213" />
                    <path className={styles.factsheetIcon} d="M30,15v300c0,8.284,6.716,15,15,15h240c8.284,0,15-6.716,15-15V138h-30h-21.214h-71.789   c-8.284,0-15-6.716-15-15V51.213V30V0H45C36.716,0,30,6.716,30,15z M115,180h100c8.284,0,15,6.716,15,15s-6.716,15-15,15H115   c-8.284,0-15-6.716-15-15S106.716,180,115,180z M115,240h100c8.284,0,15,6.716,15,15c0,8.284-6.716,15-15,15H115   c-8.284,0-15-6.716-15-15C100,246.716,106.716,240,115,240z" />
                </svg>

                <a className={styles.infoSubtitle} href={url}>
                    {name}
                </a>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/DocumentDownload/DocumentDownload.tsx